/**
 * ChatBot Types
 * Types pour les fonctionnalités avancées du chatbot
 */

export type ChatSize = 'small' | 'medium' | 'large';
export type FontSize = 'small' | 'medium' | 'large';
export type ThemeMode = 'light' | 'dark' | 'auto';

export interface ChatSettings {
  size: ChatSize;
  fontSize: FontSize;
  theme: ThemeMode;
  suggestions: boolean;
  sound: boolean;
  animations: boolean;
}

export interface QuickAction {
  id: string;
  label: string;
  message: string;
  icon: string;
  category: string;
}

export interface ChatMessage {
  id: string;
  text: string;
  sender: 'user' | 'bot';
  timestamp: Date;
  isTyping?: boolean;
}

export interface SettingsSection {
  id: string;
  title: string;
  icon: string;
  expanded: boolean;
}

export const CHAT_SIZES: { [key in ChatSize]: { width: string; height: string; icon: string; label: string; description: string } } = {
  small: {
    width: '320px',
    height: '450px',
    icon: '📱',
    label: 'Compact',
    description: 'Interface minimaliste'
  },
  medium: {
    width: '380px',
    height: '550px',
    icon: '💻',
    label: 'Standard',
    description: 'Taille recommandée'
  },
  large: {
    width: '450px',
    height: '650px',
    icon: '🖥️',
    label: 'Étendu',
    description: 'Interface spacieuse'
  }
};

export const FONT_SIZES: { [key in FontSize]: { size: string; icon: string; label: string } } = {
  small: { size: '0.8rem', icon: '🔤', label: 'Petit' },
  medium: { size: '0.9rem', icon: '🔤', label: 'Moyen' },
  large: { size: '1rem', icon: '🔤', label: 'Grand' }
};

export const QUICK_ACTIONS: QuickAction[] = [
  {
    id: 'about',
    label: 'À propos de moi',
    message: 'Peux-tu me parler de ton parcours professionnel ?',
    icon: '👤',
    category: 'Portfolio'
  },
  {
    id: 'skills',
    label: 'Compétences techniques',
    message: 'Quelles sont tes compétences principales en développement ?',
    icon: '💻',
    category: 'Portfolio'
  },
  {
    id: 'projects',
    label: 'Projets récents',
    message: 'Montre-moi tes projets les plus intéressants',
    icon: '🚀',
    category: 'Portfolio'
  },
  {
    id: 'contact',
    label: 'Contact',
    message: 'Comment puis-je te contacter pour un projet ?',
    icon: '📧',
    category: 'Portfolio'
  },
  {
    id: 'experience',
    label: 'Expérience',
    message: 'Raconte-moi ton expérience professionnelle',
    icon: '💼',
    category: 'Portfolio'
  },
  {
    id: 'formation',
    label: 'Formation',
    message: 'Quel est ton parcours de formation ?',
    icon: '🎓',
    category: 'Portfolio'
  },
  {
    id: 'technologies',
    label: 'Technologies préférées',
    message: 'Quelles technologies tu préfères utiliser ?',
    icon: '⚙️',
    category: 'Portfolio'
  },
  {
    id: 'collaboration',
    label: 'Collaboration',
    message: 'Es-tu disponible pour de nouveaux projets ?',
    icon: '🤝',
    category: 'Portfolio'
  },
  {
    id: 'hello',
    label: 'Saluer',
    message: 'Salut ! Comment ça va ?',
    icon: '👋',
    category: 'Général'
  },
  {
    id: 'help',
    label: 'Aide',
    message: 'Comment puis-je utiliser ce chatbot ?',
    icon: '❓',
    category: 'Général'
  },
  {
    id: 'portfolio-tech',
    label: 'Tech de ce portfolio',
    message: 'Avec quoi ce portfolio a été développé ?',
    icon: '🛠️',
    category: 'Général'
  }
];
